<template>
  <div class="pagination-component">
    <p class="navigation" @click="handlePreviousClick">
      <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        `
        <path
          d="M6.9944 1L0.999992 6L6.9944 11"
          stroke="#979797"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      Previous
    </p>
    <p
      class="pagination-item"
      :class="state.currentPage === item ? 'active' : ''"
      v-for="(item, index) in newArrayWithNumbers()"
      :key="item"
    >
      <span @click="() => handleNavigation(item)">{{ item }}</span>
    </p>
    <p class="navigation next" @click="handleNextClick">
      Next
      <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.707397 1L6.70181 6L0.707397 11"
          stroke="#e00b5b"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </p>
  </div>
</template>
<script>
import { reactive } from "@vue/composition-api";
export default {
  name: "Pagination",
  props: {
    numberOfPages: Number,
    currentPage: Number,
    linkGen: Function,
    useQuery: {
      type: Boolean,
      default: true
    },
    handlePageChange: {
      type: Function,
      default: () => {}
    }
  },
  setup(props, { root }) {
    const state = reactive({
      currentPage:  Number(root.$route.query.page) || 1,
      startPage:  Number(root.$route.query.page) || 1,
    });

    const returnQuery = () => {
      let queryParams = Object.entries(root.$route.query);
      let generatedQuery = "";
      let i = 0;
      // Loop through arrays and generate the query string
      for (let [name, value] of queryParams) {
        if (name !== "page") {
          generatedQuery += `${name}=${value}`;
        }
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }

      return generatedQuery;
    };

    const handleNavigation = (index) => {
      state.currentPage = index;

      if (
        (index === state.startPage + 2 &&
          props.numberOfPages > state.startPage + 2) ||
        index === props.numberOfPages
      ) {
        state.startPage = index;
      }

      if(props.useQuery) {
        root.$router.push(`${root.$route.path}?${returnQuery()}page=${index}`);
      } else {
        props.handlePageChange(index)
      }
    };

    const handlePreviousClick = () => {
      if (state.startPage - 1 >= 1) {
        state.startPage = state.startPage - 1;
        state.currentPage = state.currentPage - 1;
      }

      if(props.useQuery) {
        root.$router.push(
          `${root.$route.path}?${returnQuery()}page=${state.currentPage}`
        )
      } else {
        props.handlePageChange(state.currentPage)
      }
    };

    const handleNextClick = () => {
      if (state.currentPage + 1 <= props.numberOfPages) {
        state.startPage = state.startPage + 1;
        state.currentPage = state.currentPage + 1;
    
        if(props.useQuery) {
          root.$router.push(
            `${root.$route.path}?${returnQuery()}page=${state.currentPage}`
          )
        } else {
          props.handlePageChange(state.currentPage)
        }
      }

    };

    const newArrayWithNumbers = () => {
      const array = [];

      if (state.currentPage - 1 > 0) {
        array.push(state.currentPage - 1);
      }

      for (let index = 0; index < 2; index++) {
        if (props.numberOfPages >= state.currentPage + index) {
          array.push(state.currentPage + index);
        }
      }

      if (array[array.length - 1] === 2 && props.numberOfPages > 3) {
        array.push(3);
      }

      return array;
    };

    return {
      state,
      handleNavigation,
      handlePreviousClick,
      handleNextClick,
      newArrayWithNumbers,
    };
  },
};
</script>

<style lang="scss">
.pagination-component {
  display: flex;
  margin: 20px 0;

  p {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  svg {
    margin: 10px;
  }

  .navigation {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #979797;
    cursor: pointer;
  }

  .next {
    color: #e00b5b;
  }

  .pagination-item {
    margin-left: 30px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  .next {
    margin-left: 30px;
  }

  .active {
    background: #e00b5b;
    border-radius: 4px;
    color: #ffffff;
  }
}
</style>